import PropTypes from 'prop-types';
import styles from './Container.module.css';

/**
 * Container - Max-width wrapper with responsive padding
 * Centers content and provides consistent horizontal spacing
 */
export function Container({
  children,
  size = 'lg',
  padding = true,
  center = true,
  fullHeight = false,
  className = '',
  ...props
}) {
  const classNames = [
    styles.container,
    styles[size],
    padding && styles.padding,
    center && styles.center,
    fullHeight && styles.fullHeight,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classNames} {...props}>
      {children}
    </div>
  );
}

Container.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', '2xl', 'full']),
  padding: PropTypes.bool,
  center: PropTypes.bool,
  fullHeight: PropTypes.bool,
  className: PropTypes.string,
};

export default Container;
